<template>
	<div>
		<el-drawer :visible.sync="drawerState" :modal="false">
			<div class="editInfo">
				<span class="pageHeader title">修改信息</span>
				<el-form
					class="editform"
					size="medium"
					label-width="120px"
					label-position="right"
				>
					<el-form-item label="账号">
						<el-input
							size="medium"
							class="el-input_style"
							v-model="numbss"
							placeholder="请输入"
						></el-input>
					</el-form-item>
					<!-- <el-form-item label="微信">
						<span v-if="account_openid">已绑定</span>
						<span v-else> 未绑定 </span>
						<el-button
							type="primary"
							size="mini"
							style="margin-left: 20px"
							@click="dialogVisBtn"
							>{{ account_openid ? '更改绑定' : '点击绑定' }}</el-button
						>
					</el-form-item> -->
					<el-form-item label="名称">
						<el-input
							size="medium"
							class="el-input_style"
							v-model="nameN"
							placeholder="请输入"
						></el-input>
					</el-form-item>
					<el-form-item label="手机号">
						{{ account_mobile }}
						<el-button
							:disabled="isDisabled"
							@click="getCodeClick($event, 1)"
							type="primary"
							size="mini"
							v-if="!isGetCodeBtnLoading"
							>{{ getCodeTextOne }}</el-button
						>
					</el-form-item>
					<el-form-item label="验证码">
						<el-input
							size="medium"
							class="el-input_style"
							v-model="smsCode"
							placeholder="请输入验证码"
						></el-input>
					</el-form-item>
					<!-- <el-form-item label="新手机号">
						<div class="flexz">
							<el-input
								size="medium"
								class="el-input_style"
								v-model="new_mobile"
								autocompconste="off"
								:maxlength="11"
								placeholder="请输入新手机号"
							></el-input>
							<div class="btnz">
								<el-button
									:disabled="isDisabled1"
									@click="getCodeClick($event, 2)"
									type="primary"
									size="mini"
									v-if="!isGetCodeBtnLoading1"
									>{{ getCodeTextOne1 }}</el-button
								>
							</div>
						</div>
					</el-form-item> -->
					<!-- <el-form-item label="新手机号验证码">
						<el-input
							size="medium"
							class="el-input_style"
							v-model="new_smsCode"
							placeholder="请输入新手机号验证码"
						></el-input>
					</el-form-item> -->
					<el-form-item label="新密码" prop="pass">
						<el-input
							size="medium"
							class="el-input_style"
							type="password"
							v-model="retrieveForm.pass"
							autocompconste="off"
							placeholder="请输入新密码"
						></el-input>
					</el-form-item>
					<el-form-item
						style="margin-top: 10px"
						label="确认密码"
						prop="checkPass"
					>
						<el-input
							size="medium"
							class="el-input_style"
							type="password"
							v-model="retrieveForm.checkPass"
							autocompconste="off"
							placeholder="请输入确认密码"
						></el-input>
					</el-form-item>
				</el-form>
				<div class="btn_submission">
					<!-- <el-button type="primary" plain @click="dialogVisible = false">关闭</el-button> -->
					<el-button
						style="margin-left: 50px"
						type="primary"
						@click="submitForm"
						>确认修改</el-button
					>
				</div>
				<el-dialog
					title="绑定微信"
					:modal="false"
					:visible.sync="dialogVisible"
					width="30%"
				>
					<!-- <div>请用微信扫一扫绑定微信</div> -->
					<div class="QRimg">
						<div class="tip">使用微信扫一扫进行绑定</div>
						<div id="login_container" style="text-align: center"></div>
					</div>
				</el-dialog>
			</div>
		</el-drawer>
	</div>
</template>
<script>
import { checkSms, smsSend, qaChangePass } from '@/api/login.js'
import md5 from '../../utils/md5'
import regExpCollection from '../../utils/regExpCollection'
import { bindWx, getAccountInfo, forgetLogin } from '@/api/login.js'
export default {
	data() {
		return {
			drawerState: false,
			password: '',
			isGetCodeBtnLoading: false, // 获取验证码按钮是否loading状态
			isDisabled: false, // 控制获取验证码按钮的禁用状态
			isGetCodeBtnLoading1: false, // 获取验证码按钮是否loading状态
			isDisabled1: false, // 控制获取验证码按钮的禁用状态
			num: 60, //验证码倒计时
			getCodeTextOne: '获取验证码',
			num1: 60, //验证码倒计时
			getCodeTextOne1: '获取新验证码',
			account: '',
			retrieveForm: {
				pass: '',
				checkPass: ''
			},
			account_mobile: "", // 手机号
			numbss: "", // 账号名称
			nameN: "", // 名称
			// account_openid: localStorage.getItem('account_openid'),
			new_mobile: '', //新手机号
			account_openid: '',
			dialogVisible: false,
			smsCode: '', //原手机验证码
			new_smsCode: '', //新手机验证码
			retrieveRules: {
				pass: [
					{
						trigger: 'blur',
						validator: (rule, value, callback) => {
							if (value === '') {
								callback(new Error('请输入密码'))
							} else {
								if (this.retrieveForm.checkPass !== '') {
									this.$refs.retrieveForm.validateField('checkPass')
								}
								callback()
							}
						}
					},
					{
						min: 8,
						max: 15,
						message: '密码长度应大于等于8个字符小于16个字符!'
					},
					{
						trigger: 'blur',
						validator: (rule, value, callback) => {
							var passwordreg =
								/(?![A-Z]*$)(?![a-z]*$)(?![0-9]*$)(?![^a-zA-Z0-9]*$)/
							if (!passwordreg.test(value)) {
								callback(
									new Error(
										'密码必须由大写字母、小写字母、数字、特殊符号中的2种及以上类型组成!'
									)
								)
							} else {
								callback()
							}
						}
					}
				],
				checkPass: [
					{
						trigger: 'blur',
						validator: (rule, value, callback) => {
							if (value === '') {
								callback(new Error('请再次输入密码'))
							} else if (value !== this.ruleForm.pass) {
								callback(new Error('两次输入密码不一致!'))
							} else {
								callback()
							}
						}
					}
				]
			},
			code: '', //绑定微信
			state: ''
		}
	},
	mounted() {
		let idxi = JSON.parse(localStorage.getItem('idxi'))
		this.account_mobile = idxi.phone, // 手机号
		this.numbss = idxi.account_name, // 账号名称
		this.nameN = idxi.nickname, // 名称
		this.getAccountInfos()
	},
	// computed: {
	//   getCodeTextOne() {
	//     // 根据表示计时器的数字的变化来决定按钮标题的文本
	//     if (this.num < 60 && this.num > 0) {
	//       // 当数字在60和0之间时，说明计时正在进行，按钮应该显示计时数字
	//       return '重新发送(' + this.num + ')'
	//     } else {
	//       // 否则，计时没有进行，所以按钮上的文字应该为默认文字，此时按钮没有禁用（具体逻辑在watch中）
	//       return '获取验证码'
	//     }
	//   }
	// },
	watch: {
		drawerState(val) {
			if (val) {
				this.retrieveForm = {
					pass: '',
					checkPass: ''
				}
				this.new_mobile = ''
				this.new_smsCode = ''
			}
		},
		// 显示原手机号显示
		isDisabled(val) {
			if (val) {
				const interval = setInterval(() => {
					// 让表示计时的数字自减1
					this.num--
					if (this.num <= 0) {
						// 当数字小于等于0时，将其值还原为60以便下次点击时还是从60开始
						this.num = 60
						// 当数字小于等于0时，将按钮解禁，能继续第二次获取验证码
						this.isDisabled = false
						// 当数字小于等于0时，清除计时器，计时停止
						clearInterval(interval)
					}
				}, 1000)
			}
		},
		// 显示新手机显示
		isDisabled1(val) {
			if (val) {
				const interval = setInterval(() => {
					// 让表示计时的数字自减1
					this.num1--
					if (this.num1 <= 0) {
						// 当数字小于等于0时，将其值还原为60以便下次点击时还是从60开始
						this.num1 = 60
						// 当数字小于等于0时，将按钮解禁，能继续第二次获取验证码
						this.isDisabled1 = false
						// 当数字小于等于0时，清除计时器，计时停止
						clearInterval(interval)
					}
				}, 1000)
			}
		},
		// "$route.query.code": {
		// 	immediate: true,
		// 	handler() {
		// 		this.code = this.$route.query.code
		// 		console.log('xxxxxxx',this.$route.query.code)
		// 	},
		// },
		// "$route.query.state": {
		// 	immediate: true,
		// 	handler() {
		// 		this.state = this.$route.query.state
		// 		console.log('xxxxxxx',this.state)
		// 	},
		// },
		// 监听路由参数
		$route: {
			handler(to, from) {
				if (to.query.code) {
					this.code = to.query.code
				}
				if (to.query.state) {
					this.state = to.query.state
				}
				if (this.code && this.state) {
					this.getOpenId()
					this.dialogVisible = false
					this.code = ''
					this.state = ''
				}
				console.log('监听路由参数----', to.query)
			},
			// 深度观察监听
			deep: true
		}
	},

	methods: {
		/**
		 * @description: 获取个人信息
		 * @return {*}
		 */
		async getAccountInfos() {
			const res = await getAccountInfo()
			if (res !== undefined && res.status === 200000) {
				// this.account_name = res.data.account_name
				// this.account_mobile = res.data.account_mobile
				// this.account_openid = res.data.account_openid
			}
		},
		// 获取openId
		async getOpenId() {
			const dataS = await bindWx({ code: this.code, state: this.state })
			if (dataS !== undefined && dataS.status === 200000) {
				this.getAccountInfos()
				this.$message.success(dataS.describe)
				this.$emit('getHeadimgurl', dataS.data.headimgurl)
			}
		},

		/**
		 * @description: 绑定微信
		 * @return {*}
		 */
		dialogVisBtn() {
			// setTimeout(() => {
			// 	new WxLogin({
			// 		self_redirect: false,
			// 		id: 'login_container',
			// 		appid: 'wx009a18b74f14bfcd',
			// 		// appid: 'wxc5198bf541f3bb78',
			// 		scope: 'snsapi_login',
			// 		// redirect_uri: encodeURIComponent('https://www.canhe.cc/#/login'),
			// 		redirect_uri: encodeURIComponent(
			// 			'https://www.ccfr.com.cn/#/homePage/homePage'
			// 		),
			// 		state: 'bind',
			// 		style: 'black',
			// 		href: 'https://sun-lawyer-test.oss-cn-beijing.aliyuncs.com/qrcode.css'
			// 	})
			// }, 200)

			this.dialogVisible = true
		},
		// 获取验证码 1手机号 2新手机号
		getCodeClick(target, tag) {
			if (tag == 1) {
				if (!regExpCollection.mob.test(this.account_mobile))
					return this.$message.warning('请输入正确的手机号')
				this.settime(target)
				this.smsSend()
				return
			} else {
				if (!regExpCollection.mob.test(this.new_mobile))
					return this.$message.warning('请输入正确的新手机号')
				this.settime1(target)
				this.smsSend1()
			}
		},
		// 发送原手机验证码
		settime() {
			this.num--
			this.getCodeTextOne = `重新发送${this.num}`
			this.isDisabled = true
			const interval = setInterval(() => {
				// 让表示计时的数字自减1
				this.num--
				this.getCodeTextOne = `重新发送${this.num}`
				if (this.num <= 0) {
					// 当数字小于等于0时，将其值还原为60以便下次点击时还是从60开始
					this.num = 60 // 当数字小于等于0时，将按钮解禁，能继续第二次获取验证码
					this.isDisabled = false // 当数字小于等于0时，清除计时器，计时停止
					this.getCodeTextOne = '获取验证码'
					clearInterval(interval)
				}
			}, 1000)
		},

		// 发送新手机验证码
		settime1() {
			this.num1--
			this.getCodeTextOne1 = `重新发送${this.num1}`
			this.isDisabled1 = true
			const interval = setInterval(() => {
				// 让表示计时的数字自减1
				this.num1--
				this.getCodeTextOne1 = `重新发送${this.num1}`
				if (this.num1 <= 0) {
					// 当数字小于等于0时，将其值还原为60以便下次点击时还是从60开始
					this.num1 = 60 // 当数字小于等于0时，将按钮解禁，能继续第二次获取验证码
					this.isDisabled1 = false // 当数字小于等于0时，清除计时器，计时停止
					this.getCodeTextOne1 = '获取新验证码'
					clearInterval(interval)
				}
			}, 1000)
		},

		// 短信验证码验证
		async checkSms(checkForm) {
			const dataS = await checkSms(checkForm)
			if (dataS.status != '200000') {
				this.$message.error(dataS.describe)
			}
		},
		// 短信下发 tag 1是原手机号 2是新手机号
		async smsSend(type = 'changePass') {
			// 随机数
			var randomNum = Math.random().toString().slice(-6)
			// 截掉字符串前2位
			const str1 = randomNum.substring(0, 2)
			// 截取字符串后1位
			const str2 = randomNum.substring(randomNum.length - 1)
			const str3 = `${str1}${this.account_mobile}${str2}`
			const str4 = md5.hex_md5(str3) // 一次加密
			const sign = md5.hex_md5(str4) // 二次加密
			let data = await smsSend(
				this.account_mobile,
				randomNum,
				sign,
				type,
				this.account_openid
			)
			if (!data) {
				this.isGetCodeBtnLoading = false // 获取验证码按钮是否loading状态
				this.isDisabled = false // 控制获取验证码按钮的禁用状态
				this.getCodeTextOne = '获取验证码'
				this.num = 0
			}
		},

		async smsSend1(type = 'register') {
			// 随机数
			var randomNum = Math.random().toString().slice(-6)
			// 截掉字符串前2位
			const str1 = randomNum.substring(0, 2)
			// 截取字符串后1位
			const str2 = randomNum.substring(randomNum.length - 1)
			const str3 = `${str1}${this.new_mobile}${str2}`
			const str4 = md5.hex_md5(str3) // 一次加密
			const sign = md5.hex_md5(str4) // 二次加密
			let data = await smsSend(
				this.new_mobile,
				randomNum,
				sign,
				type,
				this.account_openid
			)
			if (!data) {
				this.isGetCodeBtnLoading1 = false // 获取验证码按钮是否loading状态
				this.isDisabled1 = false // 控制获取验证码按钮的禁用状态
				this.getCodeTextOne1 = '获取新验证码'
				this.num1 = 0
			}
		},
	

		// 提交
		submitForm() {
			// this.registrationNex()
			// this.judgePassword()
			if (this.new_mobile) {
				// if (!regExpCollection.mob.test(this.new_mobile)) {
				// 	this.$message.error('请输入正确的手机号')
				// 	return
				// }

				// if (!this.new_smsCode) {
				// 	this.$message.error('请填写新手机验证码')
				// 	return
				// }

				// const reg = /^\d{6}\b/
				// if (!reg.test(this.new_smsCode) || this.new_smsCode.length !== 6) {
				// 	this.$message.error('手机验证码应为6位纯数字')
				// 	return
				// }
				// if (!this.smsCode) {
				// 	this.$message.error('请填写原手机验证码')
				// 	return
				// }
			}
			if (!this.nameN) {
				this.$message.error('请输入用户名')
				return
			}
			if (this.retrieveForm.pass) {
				if (
					this.retrieveForm.pass.length < 8 ||
					this.retrieveForm.pass.length > 20
				) {
					this.$message.error('密码长度范围应为8-20位')
					return
				}

				if (!this.retrieveForm.checkPass) {
					this.$message.error('请输入确认密码')
					return
				}

				if (this.retrieveForm.pass !== this.retrieveForm.checkPass) {
					this.$message.error('两次输入的密码不一致，请检查后重新输入')
					return
				}
				if (!this.smsCode) {
					this.$message.error('请输入验证码')
					return
				}
			}

			const changePwdForm = {
				mobile: this.account_mobile,
				account: this.numbss,
				password: this.retrieveForm.pass,
				password_confirmation: this.retrieveForm.checkPass,
				smsCode: this.smsCode,
				nickname: this.nameN
			}

			this.forgetLogin(changePwdForm)
		},
			// 忘记密码
		async forgetLogin(changePwdForm) {
			const dataS = await qaChangePass(changePwdForm)
			if (dataS) {
				if (dataS.status == 200000) {
					this.$message.success(dataS.describe) // 跳回首页
					this.drawerState = false
					if (changePwdForm.password) {
						setTimeout(() => {
							this.logout()
						}, 1000)
					}
					
				}
			}
		},
		async logout() {
			const result = await this.$store.dispatch('user/logout')
			// localStorage.removeItem('headimg')
			localStorage.clear()
			localforage.clear()
		 
		}
	}
}
</script>
<style lang="scss" scoped>
.editInfo {
	::v-deep .el-input {
		display: block;
	}

	::v-deep .el-input--medium .el-input__inner {
		height: 36px;
		line-height: 36px;
	}
}

.QRimg {
	height: 360px;
	width: 100%;
	position: relative;

	.tip {
		font-size: 12px;
		text-align: center;
		margin-bottom: 10px;
	}
}
.flexz {
	display: flex;
	.btnz {
		margin-left: 10px;
	}
}
.title {
	// margin-left: 20px;
}

.editInfo {
	width: 90%;
	margin: 0 auto;
}

.editform {
	margin-left: 10%;
	margin-top: 5%;
}

.el-input_style {
	width: 60%;
}

.btn_submission {
	text-align: center;
	margin-bottom: 20px;
	margin-top: 60%;
}
</style>
